import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import axios from "axios";
import { Link, Navigate, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { toast, ToastContainer } from "react-toastify";
import { useAuthContext } from "../Contexts/AuthContext";

const Register = ({ }) => {
  const [creds, setCreds] = useState({});
  const [success, setSuccess] = useState(false);
  const [loading, setloading] = useState(false);
  const [robot, setRobot] = useState(true);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const HandleRegister = async (e) => {
    e.preventDefault();
    if (
      creds?.email?.length > 0 &&
      creds?.password?.length > 0 &&
      creds?.cpassword?.length > 0 &&
      robot
    ) {
      if (document.getElementById("flexCheckDefault").checked) {
        if (creds.password === creds.cpassword) {
          setloading(true);
          try {
            await axios.post(
              process.env.REACT_APP_BASE_URL + "/api/auth/register",
              {
                ...creds,
                email: creds.email.toLowerCase(),
              }
            );
            setSuccess(true);
            document.querySelectorAll("input").forEach((inp) => {
              inp.value = "";
            });
            setloading(false);
            toast.success(
              "Activa tu Cuenta Transferven desde tu email para poder acceder.",
              {
                position: "top-center",
                theme: "dark",
              }
            );
          } catch (err) {
            console.log(err);
            setloading(false);
            toast.error(err.response?.data?.error, {
              position: "top-center",
              theme: "dark",
            });
            setSuccess(false);
          }
        } else {
          toast.error("Contraseñas no coinciden!", {
            position: "top-center",
            theme: "dark",
          });
        }
      } else {
        toast.error("Acepta nuestros Términos y Condiciones", {
          position: "top-center",
          theme: "dark",
        });
      }
    } else {
      toast.error("Completar todos los datos!", {
        position: "top-center",
        theme: "dark",
      });
    }
  };

  const HandleChange = (e) => {
    setCreds((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  function onChange(value) {
    setRobot(value);
  }

  useEffect(() => {
    const ScrollToTop = () => {
      window.scrollTo(0, 0);
    };
    ScrollToTop();
  }, []);

  if (user) return <Navigate to={"/"} />;

  return (
    <>
      <style>{`
        .wv-reg {
          /* --- brand accent (Walletven red). Change here if the exact hex differs --- */
          --accent: #F6394F;
          --accent-strong: #e22440;

          --ink: #101828;
          --muted: #667085;
          --label: #475467;
          --field: #f5f6f8;
          --field-border: #ececf0;
          --card-border: #ececec;

          min-height: 100vh;
          background: #ffffff;
          color: var(--ink);
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 96px 20px 72px;
          box-sizing: border-box;
        }

        .wv-reg * { box-sizing: border-box; }

        .wv-reg .wv-card {
          width: 100%;
          max-width: 720px;
          background: #ffffff;
          border: 1px solid var(--card-border);
          border-radius: 20px;
          padding: 48px;
          box-shadow: 0 12px 44px rgba(16, 24, 40, 0.06);
        }

        .wv-reg h1 {
          margin: 0 0 12px;
          font-size: 2.1rem;
          font-weight: 800;
          letter-spacing: -0.02em;
          color: #0f1620;
        }

        .wv-reg .wv-sub {
          margin: 15px 0px;
          color: var(--muted);
          font-size: 1rem;
          line-height: 1.55;
        }

        .wv-reg .wv-field { margin-bottom: 20px; }

        .wv-reg .wv-field label {
          display: block;
          margin-bottom: 8px;
          color: var(--label);
          font-weight: 600;
          font-size: 0.95rem;
        }

        .wv-reg .wv-input {
          width: 100%;
          background: var(--field);
          border: 1px solid var(--field-border);
          border-radius: 11px;
          padding: 15px 16px;
          font-size: 1rem;
          color: var(--ink);
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
        }

        .wv-reg .wv-input::placeholder { color: #98a2b3; }

        .wv-reg .wv-input:focus {
          background: #ffffff;
          border-color: var(--accent);
          box-shadow: 0 0 0 3px rgba(246, 57, 79, 0.14);
        }

        .wv-reg .wv-hint {
          margin: 6px 0 0;
          font-size: 0.8rem;
          color: #98a2b3;
        }

        .wv-reg .wv-check {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          margin: 8px 0 4px;
        }

        .wv-reg .wv-check input[type="checkbox"] {
          width: 20px;
          height: 20px;
          margin-top: 1px;
          accent-color: var(--accent);
          flex-shrink: 0;
          cursor: pointer;
        }

        .wv-reg .wv-check label {
          font-size: 0.86rem;
          line-height: 1.5;
          color: var(--muted);
        }

        .wv-reg .wv-check a { color: var(--accent); text-decoration: none; }
        .wv-reg .wv-check a:hover { text-decoration: underline; }

        .wv-reg .wv-recaptcha-error {
          color: var(--accent);
          font-size: 0.85rem;
          margin: 10px 0 0;
        }

        .wv-reg .wv-submit {
          width: 100%;
          margin-top: 16px;
          padding: 16px;
          background: var(--accent);
          color: #ffffff;
          font-weight: 700;
          font-size: 1rem;
          border: none;
          border-radius: 11px;
          cursor: pointer;
          transition: background 0.15s ease, transform 0.05s ease;
        }

        .wv-reg .wv-submit:hover:not(:disabled) { background: var(--accent-strong); }
        .wv-reg .wv-submit:active:not(:disabled) { transform: translateY(1px); }
        .wv-reg .wv-submit:disabled { opacity: 0.6; cursor: not-allowed; }

        .wv-reg .wv-help {
          display: block;
          text-align: center;
          margin-top: 18px;
          color: #98a2b3;
          font-size: 0.88rem;
          text-decoration: none;
        }
        .wv-reg .wv-help:hover { color: var(--accent); }

        .wv-reg .wv-switch {
          text-align: center;
          margin-top: 14px;
          font-size: 0.9rem;
          color: var(--muted);
        }
        .wv-reg .wv-switch a { color: var(--accent); text-decoration: none; }
        .wv-reg .wv-switch a:hover { text-decoration: underline; }

        @media (max-width: 640px) {
          .wv-reg { padding: 84px 16px 48px; }
          .wv-reg .wv-card { padding: 28px; border-radius: 16px; }
          .wv-reg h1 { font-size: 1.7rem; }
        }
      `}</style>

      <Navbar />
      <div className="wv-reg">
        <ToastContainer />

        <form className="wv-card" onSubmit={HandleRegister}>
          <h1>Crea tu cuenta</h1>
          <p className="wv-sub">
            Abre tu Cuenta y empieza a enviar dinero a tus familiares y amigos en
            pocos minutos.
          </p>

          <div className="wv-field" style={{marginTop: "15px"}}>
            <label htmlFor="email">Correo</label>
            <input
              type={"email"}
              placeholder="tucorreo@ejemplo.com"
              className="wv-input"
              id="email"
              onChange={(e) => HandleChange(e)}
            />
            <p className="wv-hint">Debes ser mayor de 18 años.</p>
          </div>

          <div className="wv-field">
            <label htmlFor="password">Contraseña</label>
            <input
              type={"password"}
              placeholder="Crea tu contraseña"
              className="wv-input"
              id="password"
              onChange={(e) => HandleChange(e)}
              autoComplete="false"
            />
          </div>

          <div className="wv-field">
            <label htmlFor="cpassword">Confirmar contraseña</label>
            <input
              type={"password"}
              placeholder="Repite tu contraseña"
              className="wv-input"
              id="cpassword"
              onChange={(e) => HandleChange(e)}
              autoComplete="false"
            />
          </div>

          <div className="wv-check">
            <input type="checkbox" id="flexCheckDefault" />
            <label htmlFor="flexCheckDefault">
              Haciendo click aquí, aceptas nuestros{" "}
              <Link to="/terms" target="_blank">
                Términos y Condiciones
              </Link>{" "}
              y{" "}
              <Link to={"/protection"} target="_blank">
                Política general en materia de Protección de Datos
              </Link>{" "}
              de Transferven y nos autorizas a contactarte por E-mail, SMS y
              Whatsapp.
            </label>
          </div>

          {/* <ReCAPTCHA
            sitekey="6Ld2YggpAAAAACwfxHxBPm1_LxtxDO17jtULGO3T"
            onChange={onChange}
            onExpired={(e) => e.reset()}
          /> */}

          {!robot && <p className="wv-recaptcha-error">Verify Recaptcha!</p>}

          <button type="submit" className="wv-submit" disabled={loading}>
            {loading ? "ENVIANDO" : "REGISTRARME"}
          </button>

          <a
            className="wv-help"
            href="https://wa.me/34620818181"
            target="_blank"
            rel="noreferrer"
          >
            ¿Necesitas ayuda?
          </a>

          <p className="wv-switch">
            ¿Ya tienes cuenta? <Link to="/login">Inicia sesión</Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default Register;